<div class="row mt-3 mb-3">
  <div class="col-sm-12">
    <div class="row" *ngIf="!(isMobile | async)">
      <ng-container *ngFor="let step of stepper">
        <div class="col-sm-3 d-flex justify-content-center">
          <div class="step-div border rounded-circle" [ngClass]="step.status">
            <li class="nav-item letter-div">
              <a class="stepLetter" role="button">
                {{ step.id }}
              </a>
            </li>
          </div>
          <div class="stepper-text">
            {{ step.name }}
          </div>
        </div>
      </ng-container>
    </div>

    <div class="row d-flex justify-content-center" *ngIf="(isMobile | async)">
      <ng-container *ngFor="let step of stepper">
        <div class="col-sm-6">
          <div class="row">
            <div class="col-sm-3 w-25">
              <div class="step-div border rounded-circle" [ngClass]="step.status">
                <li class="nav-item letter-div">
                  <a class="stepLetter" role="button">
                    {{ step.id }}
                  </a>
                </li>
              </div>
            </div>
            <div class="col-sm-9 w-75">
              <div class="stepper-text">
                {{ step.name }}
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="activeStep == 1">
      <div class="row justify-content-center" *ngIf="(newPurchaseQuoteError$ | async)">
        <div class="col-sm-12 d-flex justify-content-center">
          <tan-alert-message [errorType]="'error'" [message]="'Could not create Quote'"></tan-alert-message>
        </div>
      </div>

      <div class="container custom-section">
        <div class="row mt-2">
          <div class="col-sm-12">
            <span class="section-heading">Basic details</span>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-sm-12">
            <span class="guidance-text">Required fields are indicated with a <strong>'*'</strong></span>
          </div>
        </div>

        <form class="mt-3" [formGroup]="quoteForm">
          <div class="row form-group" *ngIf="isStaff">
            <div class="col-sm-4">
              <label class="control-label" for="customer">* Customer</label>
              <input type="text" class="form-control" formControlName="customer" placeholder="Please select a customer">
            </div>
            <div class="col-sm-2 top-margin">
              <div class="btn-group fr">
                <button id="CustomersByButton" type="button" class="btn btn-primary dropdown-toggle"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span>Search Customer</span>
                </button>
                <div class="dropdown-menu p-0 dropdown-menu-position" aria-labelledby="CustomersByButton">
                  <div class="dropdown-divider m-0"></div>
                  <div class="form-group select-margin-bottom search-dropdown-box p-1 m-0">
                    <input class="form-control" id="search-text" type="text" formControlName="searchCustomer"
                      [(ngModel)]="searchText" (ngModelChange)="searchCustomers()" placeholder="Search customers" />
                  </div>
                  <div class="dropdown-divider m-0"></div>

                  <div class="search-items">
                    <tan-loader [loading]="(customersLoading$ | async)" [loadingText]="'<p>Searching customers</p>'">
                    </tan-loader>
                    <div *ngIf="!(customersLoading$ | async) && customers.length > 0">
                      <button class="dropdown-item" (click)="setSelectedCustomer(customer)"
                        *ngFor="let customer of customers">
                        {{ customer.firstName }} {{ customer.lastName }}</button>
                    </div>
                    <div *ngIf="!(customersLoading$ | async) && customers.length == 0">
                      <button class="dropdown-item">No customers found</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-sm-12" *ngIf="showLocationDD">
              <label class="control-label" for="quote_location">Select Location</label>
              <select class="form-control" formControlName="quote_location" id="quote_location"
                (change)="setSelectedQuoteLocation()">
                <option [ngValue]="null">Please select</option>
                <option *ngFor="let local of quoteLocations" [ngValue]="local.id">{{ local.name }}</option>
              </select>
            </div>
          </div>

          <ng-container *ngIf="!isStaff && isCustomer && showLocationDD">
            <div class="form-group mb-0">
              <label class="control-label" for="quote_location">Select Location</label>
              <select class="form-control" formControlName="quote_location" id="quote_location"
                (change)="setSelectedQuoteLocation()">
                <option [ngValue]="null">Please select</option>
                <option *ngFor="let local of quoteLocations" [ngValue]="local.id">{{ local.name }}</option>
              </select>
            </div>
            <div class="row mb-2">
              <div class="col-sm-12">
                <span class="guidance-text">Choose Klipriver if your closest area is not in the list</span>
              </div>
            </div>
          </ng-container>

          <div class="row form-group">
            <div class="col-md-6 col-sm-12">
              <label class="control-label" for="building_type">* Building Type</label>
              <select class="form-control" formControlName="building_type" id="building_type"
                (change)="setBuildingType()">
                <option [ngValue]="null">Please select</option>
                <option *ngFor="let building of buildingTypes" [ngValue]="building.id">{{ building.name }}</option>
              </select>
              <span class="error"
                *ngIf="quoteForm.get('building_type').touched && quoteForm.get('building_type').errors?.required">
                Building Type is required</span>
            </div>
            <div class="col-md-6 col-sm-12">
              <label class="control-label" for="organization_sector">* Organizational Sector</label>
              <select class="form-control" formControlName="organization_sector" id="organization_sector"
                (change)="setOrganizationalSector()">
                <option [ngValue]="null">Please select</option>
                <option *ngFor="let org of organizationalTypes" [ngValue]="org.id">{{ org.name }}</option>
              </select>
              <span class="error"
                *ngIf="quoteForm.get('organization_sector').touched && quoteForm.get('organization_sector').errors?.required">
                Organizational Sector is required</span>
            </div>
          </div>

          <div class="row form-group">
            <div class="col-md-6 col-sm-12">
              <label class="control-label" for="required_by">* Approximately when is the unit required?</label>
              <select class="form-control" formControlName="required_by" id="required_by" (change)="setRequiredBy()">
                <option [ngValue]="null">Please select</option>
                <option *ngFor="let requiredOpt of requiredByTypes" [ngValue]="requiredOpt.id">{{ requiredOpt.name }}
                </option>
              </select>
              <span class="error"
                *ngIf="quoteForm.get('required_by').touched && quoteForm.get('required_by').errors?.required">
                This is a required field.</span>
            </div>
          </div>

          <div class="form-group">
            <label class="control-label" for="notes">Notes</label>
            <input type="text" class="form-control" formControlName="notes" />
          </div>

        </form>
      </div>

      <div class="container custom-section">
        <div class="row mt-2">
          <div class="col-sm-12">
            <span class="section-heading">Delivery and Collection Area</span>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-sm-12">
            <span class="guidance-text">* I would like my order to be:</span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="form-check">
              <input class="form-check-input" type="radio" name="shippingType" id="deliverShipment"
                value="deliverShipment" [checked]="deliverShipmentChecked" (change)="setDeliveryOption(true)">
              <label class="form-check-label" for="deliverShipment">
                Delivered
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="shippingType" id="collectShipment"
                value="collectShipment" [checked]="collectShipmentChecked" (change)="setDeliveryOption(false)">
              <label class="form-check-label" for="collectShipment">
                Ex-works
              </label>
            </div>
          </div>
        </div>

        <ng-container *ngIf="!deliverShipping">
          <div class="row mt-2 mb-4">
            <div class="col-sm-12">
              <span class="guidance-text">Collection from either Kwikspace Johannesburg or Western Cape manufacturing
                plants</span>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="deliverShipping">
          <div class="row mt-2">
            <div class="col-sm-12">
              <span class="guidance-text">This is the address where the modular building(s) will be delivered to</span>
            </div>
          </div>

          <form class="mt-3" [formGroup]="addressForm">

            <div class="row form-group">
              <div class="col-md-6 col-sm-12">
                <label class="control-label" for="shipping_address1">* Address line 1</label>
                <input type="text" class="form-control" formControlName="shipping_address1" />
                <span class="error"
                  *ngIf="addressForm.get('shipping_address1').touched && addressForm.get('shipping_address1').errors?.required">
                  Address line 1 is required</span>
              </div>
              <div class="col-md-6 col-sm-12">
                <label class="control-label" for="shipping_address2">Address line 2</label>
                <input type="text" class="form-control" formControlName="shipping_address2" />
              </div>
            </div>

            <div class="row form-group">
              <div class="col-md-6 col-sm-12">
                <label class="control-label" for="shipping_suburb">* Suburb</label>
                <input type="text" class="form-control" formControlName="shipping_suburb" />
                <span class="error"
                  *ngIf="addressForm.get('shipping_suburb').touched && addressForm.get('shipping_suburb').errors?.required">
                  Suburb is required</span>
              </div>
              <div class="col-md-6 col-sm-12">
                <label class="control-label" for="shipping_postal">Postal code</label>
                <input type="text" class="form-control" formControlName="shipping_postal" />
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-md-4 col-sm-12">
                <div class="form-group">
                  <label class="control-label" for="shipping_province">* Province</label>
                  <select class="form-control" formControlName="shipping_province" id="shipping_province"
                    (change)="setProvince()">
                    <option [ngValue]="null">Please select</option>
                    <option *ngFor="let province of provinces" [ngValue]="province.id">{{ province.name }}</option>
                  </select>
                  <span class="error"
                    *ngIf="addressForm.get('shipping_province').touched && addressForm.get('shipping_province').errors?.required">
                    Province is required</span>
                </div>
              </div>

              <div class="col-md-4 col-sm-12" *ngIf="showDistricts">
                <tan-loader [loading]="(transportDistrictsLoading$ | async)" [loadingText]="'<p>Loading Districts</p>'">
                </tan-loader>

                <div class="row justify-content-center" *ngIf="(transportDistrictsError$ | async)">
                  <div class="col-sm-12 d-flex justify-content-center">
                    <tan-alert-message [errorType]="'error'" [message]="'Could not retrieve Districts'">
                    </tan-alert-message>
                  </div>
                </div>

                <div class="form-group"
                  *ngIf="!(transportDistrictsLoading$ | async) && !(transportDistrictsError$ | async)">
                  <label class="control-label" for="shipping_district">* District</label>
                  <select class="form-control" formControlName="shipping_district" id="shipping_district"
                    (change)="setDistrict()">
                    <option [ngValue]="null">Please select</option>
                    <option *ngFor="let district of transportDistricts" [ngValue]="district.id">{{ district.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-4 col-sm-12" *ngIf="showAreas">
                <tan-loader [loading]="(transportAreasLoading$ | async)" [loadingText]="'<p>Loading Areas</p>'">
                </tan-loader>

                <div class="row justify-content-center" *ngIf="(transportAreasError$ | async)">
                  <div class="col-sm-2 d-flex justify-content-center">
                    <tan-alert-message [errorType]="'error'" [message]="'Could not retrieve Areas'"></tan-alert-message>
                  </div>
                </div>
                
                <div class="form-group" *ngIf="!(transportAreasLoading$ | async) && !(transportAreasError$ | async)">
                  <label class="control-label" for="shipping_area">* Area</label>
                  <select class="form-control" formControlName="shipping_area" id="shipping_area" (change)="setArea()">
                    <option [ngValue]="null">Please select</option>
                    <option *ngFor="let area of transportAreas" [ngValue]="area.id">{{ area.name }}</option>
                  </select>
                  <span class="info guidance-text-blue">Select closest Area</span>
                </div>
              </div>
            </div>

            <div class="row mb-2" *ngIf="showProvinceMsg">
              <div class="col-sm-12">
                <span class="guidance-text">**An experienced sales consultant will be in contact with you to confirm
                  your delivery location and if/where required, and provide a revised quotation**</span>
              </div>
            </div>
          </form>
        </ng-container>

      </div>

      <ng-container *ngIf="deliverShipmentChecked">
        <div class="row"
          *ngIf="quoteForm.valid && addressForm.valid && canSaveQuote && customerSelected && locationSelected">
          <div class="col-sm-12">
            <div class="container custom-section pt-2 pb-2 ar">
              <button type="button" class="btn btn-primary" (click)="saveQuote()">
                <span *ngIf="!(newPurchaseQuoteLoading$ | async)">Next</span>
                <span *ngIf="(newPurchaseQuoteLoading$ | async)"><i class="fa fa-spinner fa-spin"></i>Loading</span>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="collectShipmentChecked">
        <div class="row" *ngIf="quoteForm.valid && canSaveQuote && customerSelected && locationSelected">
          <div class="col-sm-12">
            <div class="container custom-section pt-2 pb-2 ar">
              <button type="button" class="btn btn-primary" (click)="saveQuote()">
                <span *ngIf="!(newPurchaseQuoteLoading$ | async)">Next</span>
                <span *ngIf="(newPurchaseQuoteLoading$ | async)"><i class="fa fa-spinner fa-spin"></i>Loading</span>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="activeStep == 2">
      <app-existing-templates (onSelectItem)="projectSelected($event)" (createDiagram)="createNewDiagram($event)">
      </app-existing-templates>
    </ng-container>

    <ng-container *ngIf="activeStep == 3">
      <div>
        <div class="row mt-3 justify-content-center w-100">
          <app-new-diagram [currentUser]="user" [category]="selectedCategory"></app-new-diagram>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="activeStep == 4">
      <div class="row">
        <div class="col-12">
          <app-purchase-quote-config [currentProject]="currentProject"></app-purchase-quote-config>
        </div>
      </div>
    </ng-container>

  </div>
</div>